/**
 * Guest search hook
 * Handles searching guests by name or email
 */

import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/**
 * Hook to search guests by name or email
 * @param searchTerm - Minimum 2 characters to trigger search
 */
export const useSearchGuests = (searchTerm: string) => {
  return useQuery({
    queryKey: ["guests-search", searchTerm],
    queryFn: async () => {
      if (!searchTerm || searchTerm.length < 2) return [];

      const { data: guests, error } = await supabase
        .from("guests")
        .select("*")
        .or(`name.ilike.%${searchTerm}%,email.ilike.%${searchTerm}%`)
        .limit(10);

      if (error) {
        console.error("Error searching guests:", error);
        throw error;
      }

      return guests || [];
    },
    enabled: searchTerm.length >= 2,
    staleTime: 30 * 1000,
  });
};
